"use client";
import React, { Suspense, useContext, useEffect, useState } from "react";
import dynamic from 'next/dynamic'

// const MainPoster = dynamic(() => import('@/components/mainposter'))
// const Pagination = dynamic(() => import("@/components/pagination"));
// const RecentPostBlog = dynamic(() => import("@/components/recent-post-blog"));
// const PopularTagsBlog = dynamic(() => import("@/components/popular-tags-blog"));
const MainPoster = dynamic(() => import('@/components/mainposter'), { ssr: false });
const Pagination = dynamic(() => import("@/components/pagination"), { ssr: false });
const BlogPageCard = dynamic(() => import("@/components/blog-page-card"), { ssr: false });
const RecentPostBlog = dynamic(() => import("@/components/recent-post-blog"), { ssr: false });
const PopularTagsBlog = dynamic(() => import("@/components/popular-tags-blog"), { ssr: false });



// const BlogPageCard = dynamic(() => import("@/components/blog-page-card"));


import { SearchIcon } from "@/components/icons/blog-icon/index";
import { Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchBlogs, fetchTags } from "@/redux/slices/blogSlice";
import moment from "moment";
import { LoaderContext } from "@/contexts/LoaderContext";

export default function Blog() {
  const dispatch = useDispatch();

  const [selectedTags, setSelectedTags] = useState([]); // Track selected tags
  const [page, setPage] = useState(1);
  const [limit] = useState(6);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const {showLoader, hideLoader} = useContext(LoaderContext);

  useEffect(() => {
    const fetchData = async () => {
      showLoader();
      try {
        await dispatch(fetchBlogs({ tags: selectedTags, search: searchQuery, page, limit })).unwrap();
        await dispatch(fetchTags()).unwrap();
      } catch (error) {
        console.error("Error fetching blogs or tags:", error);
      } finally {
        hideLoader();
      }
    };
  
    fetchData();
  }, [dispatch, selectedTags, searchQuery, page, limit]);
  
  const blogs = useSelector((state) => state.blogs.blogs.data);
  const totalRecords = useSelector(
    (state) => state.blogs.blogs.pagination?.total || 0
  );
  const tags = useSelector((state) => state.blogs.tags.data);

  const newProducts = blogs?.filter((item) => item.is_new);

  const handleTagSelection = (tagId) => {
    setSelectedTags((prev) => {
      if (prev.includes(tagId)) {
        return prev.filter((id) => id !== tagId);
      }
      return [...prev, tagId];
    });
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1);   
  };

  // 🔹 Handle Page Change for Pagination
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <MainPoster
        bgimg="/assets/images/my-cart/bg/bg-poster.webp"
        title="Blog"
        type="pathes"
        main="Home"
        mainhref="/"
        sub="Blog"
        subhref="/blog"
      />

        <section className="section-py blog-bg-poster">
          <div className="container-main mx-auto px-3">
            <div className="grid blogpg-content">
              <div className="g-col-12 g-col-md-7 g-col-xl-8">
                <div className="grid blogpg-subcontent">
                {blogs && blogs.length > 0 ? (
                      blogs.map((item, i) => (
                        <div className="g-col-12 g-col-xl-6" key={i}>
                          <BlogPageCard
                            src={item.blog_image}
                            alt={`${item.blog_title} Image`}
                            author={item.author}
                            date={moment(item.createAt).format("DD MMM YYYY")}
                            title={item.blog_title}
                            content={item.blog_description}
                            linkTitle="Read More"
                            href={`/blog/${item.slug}`}
                          />
                        </div>
                      ))
                    ) : (
                      <div className="g-col-12 text-center py-5">
                        <h2>No Blogs Available</h2>
                      </div>
                    )}
                </div>
              </div>
          

              <div className="g-col-12 g-col-md-5 g-col-xl-4">
                <div className="position-relative searchbar-blog">
                  <Form.Control
                    type="search"
                    className="shadow-none px-3 py-2"
                    placeholder="Search blog here"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                  <span className="position-absolute top-50 end-0 translate-middle-y me-3 z-0">
                    <SearchIcon />
                  </span>
                </div>
                {newProducts?.length > 0 && (
                   <Suspense fallback={<></>}>
 <div className="mt-4 pt-2">
                    <RecentPostBlog title="recent post" content={newProducts} />
                  </div>
                   </Suspense>
                 
                )}
                {tags?.length > 0 && (
                  <div className="mt-4 pt-3">
                    <PopularTagsBlog
                      title="popular tags"
                      content={tags}
                      onTagSelect={handleTagSelection}
                      selectedTags={selectedTags}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center mt-4 pt-1">
              <Pagination currentPage={page} limit={limit} totalRecords={totalRecords} onPageChange={handlePageChange} />
            </div>
          </div>
        </section>
      
    </>
  );
}
